import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monIsBoolean',
    standalone: false,
})
export class IsBooleanPipe implements PipeTransform {
    transform (value: unknown): boolean {
        return typeof value === 'boolean';
    }
}
